import {environment} from '../environments/environment';

export const API_URL = environment.apiUrl + '/api/';
export const TIMEOUT = 5000;
export const MAX_RETRIES = 3;
export const ERROR_MESSAGES = {
    NOT_FOUND: 'Resource not found',
    UNAUTHORIZED: 'You are not authorized to access this resource',
    SERVER_ERROR: 'Internal server error, please try again later',
};

export enum UserStatus {
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PAYMENT_COMPLETE = 'PAYMENT_COMPLETE',
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE'
}

export enum MembershipType {
    MEMBER = 'MEMBER',
    NON_MEMBER = 'NON_MEMBER',
    LIFE_MEMBER = 'LIFE_MEMBER',
    ANNUAL_MEMBER = 'ANNUAL_MEMBER'
}

// ✅ Add this Mapping
export const MembershipDisplayNames: Record<MembershipType, string> = {
    [MembershipType.MEMBER]: 'Member',
    [MembershipType.NON_MEMBER]: 'Non Member',
    [MembershipType.LIFE_MEMBER]: 'Life Member',
    [MembershipType.ANNUAL_MEMBER]: 'Annual Member'
};
export const COMMITTEE_ROLES = [
    {"id": 0, "role": "President"},
    {"id": 1, "role": "Vice President"},
    {"id": 2, "role": "General Secretary"},
    {"id": 3, "role": "Treasurer"},
    {"id": 4, "role": "Membership Secretary"},
    {"id": 5, "role": "Cultural Secretary"},
    {"id": 6, "role": "Joint Cultural Secretary"},
    {"id": 7, "role": "Cultural Coordinator"},
    {"id": 8, "role": "Cultural Coordinator"},
    {"id": 9, "role": "Magazine Secretary"},
    {"id": 10, "role": "Digital & Media Secretary"},
    {"id": 11, "role": "Event Secretary"},
    {"id": 12, "role": "Joint Event Secretary"},
    {"id": 13, "role": "Event Coordinator"},
    {"id": 14, "role": "Community Relations Secretory"},
    {"id": 15, "role": "Youth Secretary"},
    {"id": 16, "role": "Camping Secretary"},
    {"id": 17, "role": "International Relations Secretary"},
    {"id": 18, "role": "Business Development Secretary"},
    {"id": 19, "role": "Sports Secretary"},
    {"id": 20, "role": "Education Secretary"},
    {"id": 21, "role": "Matrimonial Secretary"},
    {"id": 22, "role": "Joint Communications Secretary"},
    {"id": 23, "role": "Member At Large"},
    {"id": 24, "role": "IT Secretary"},
    {"id": 25, "role": "Charity Coordinator"}
];



export const BOT_ROLES = [
    {"id": 0, "role": "Ex-President"},
    {"id": 1, "role": "BOT Member"},
    {"id": 2, "role": "BOT Youth"},
    {"id": 3, "role": "BOT Chair"}
];

export const USER_ROLES = [
    {"id": 0, "role": "NEC_PRESIDENT"},
    {"id": 1, "role": "NEC"},
    {"id": 2, "role": "CHAPTER_PRESIDENT"},
    {"id": 3, "role": "CEC"},
    {"id": 4, "role": "MEMBER"},
    {"id": 5, "role": "NON_MEMBER"}
];

export const MEMBERSHIP_TYPE = [

    {"id": 0, "memberType": "MEMBER"},
    {"id": 1, "memberType": "NON_MEMBER"},
    {"id": 3, "memberType": "LIFE_MEMBER"},
    {"id": 4, "memberType": "ANNUAL_MEMBER"}
];

export const STATES = [
    {code: 'AL', name: 'Alabama'},
    {code: 'AK', name: 'Alaska'},
    {code: 'AZ', name: 'Arizona'},
    {code: 'AR', name: 'Arkansas'},
    {code: 'CA', name: 'California'},
    {code: 'CO', name: 'Colorado'},
    {code: 'CT', name: 'Connecticut'},
    {code: 'DE', name: 'Delaware'},
    {code: 'FL', name: 'Florida'},
    {code: 'GA', name: 'Georgia'},
    {code: 'HI', name: 'Hawaii'},
    {code: 'ID', name: 'Idaho'},
    {code: 'IL', name: 'Illinois'},
    {code: 'IN', name: 'Indiana'},
    {code: 'IA', name: 'Iowa'},
    {code: 'KS', name: 'Kansas'},
    {code: 'KY', name: 'Kentucky'},
    {code: 'LA', name: 'Louisiana'},
    {code: 'ME', name: 'Maine'},
    {code: 'MD', name: 'Maryland'},
    {code: 'MA', name: 'Massachusetts'},
    {code: 'MI', name: 'Michigan'},
    {code: 'MN', name: 'Minnesota'},
    {code: 'MS', name: 'Mississippi'},
    {code: 'MO', name: 'Missouri'},
    {code: 'MT', name: 'Montana'},
    {code: 'NE', name: 'Nebraska'},
    {code: 'NV', name: 'Nevada'},
    {code: 'NH', name: 'New Hampshire'},
    {code: 'NJ', name: 'New Jersey'},
    {code: 'NM', name: 'New Mexico'},
    {code: 'NY', name: 'New York'},
    {code: 'NC', name: 'North Carolina'},
    {code: 'ND', name: 'North Dakota'},
    {code: 'OH', name: 'Ohio'},
    {code: 'OK', name: 'Oklahoma'},
    {code: 'OR', name: 'Oregon'},
    {code: 'PA', name: 'Pennsylvania'},
    {code: 'RI', name: 'Rhode Island'},
    {code: 'SC', name: 'South Carolina'},
    {code: 'SD', name: 'South Dakota'},
    {code: 'TN', name: 'Tennessee'},
    {code: 'TX', name: 'Texas'},
    {code: 'UT', name: 'Utah'},
    {code: 'VT', name: 'Vermont'},
    {code: 'VA', name: 'Virginia'},
    {code: 'WA', name: 'Washington'},
    {code: 'WV', name: 'West Virginia'},
    {code: 'WI', name: 'Wisconsin'},
    {code: 'WY', name: 'Wyoming'},
    {code: 'CAN', name: 'Canada'}
];

export const BUSINESS_CATEGORIES_GROUPED = [
    {
        group: 'Food & Beverage',
        categories: [
            {code: 'RESTAURANT', name: 'Restaurant'},
            {code: 'FOOD_TRUCK', name: 'Food Truck'},
            {code: 'CATERING', name: 'Catering Services'},
            {code: 'BAKERY', name: 'Bakery / Sweets'},
            {code: 'GROCERY', name: 'Grocery Store'},
            {code: 'MEAL_PREP', name: 'Meal Prep / Tiffin Service'}
        ]
    },
    {
        group: 'Health & Wellness',
        categories: [
            {code: 'DOCTOR', name: 'Doctor / Medical Clinic'},
            {code: 'DENTIST', name: 'Dentist'},
            {code: 'PHARMACY', name: 'Pharmacy'},
            {code: 'PHYSIOTHERAPY', name: 'Physical Therapy'},
            {code: 'HOME_HEALTH', name: 'Home Health Care'},
            {code: 'FITNESS', name: 'Fitness / Gym / Yoga'},
            {code: 'MENTAL_HEALTH', name: 'Mental Health / Counseling'},
            {code: 'AYURVEDA', name: 'Ayurveda / Naturopathy'}
        ]
    },
    {
        group: 'Beauty & Fashion',
        categories: [
            {code: 'SALON', name: 'Salon'},
            {code: 'SPA', name: 'Spa & Massage'},
            {code: 'MAKEUP', name: 'Makeup Artist'},
            {code: 'MEHNDI', name: 'Mehndi Artist'},
            {code: 'SKINCARE', name: 'Skincare'},
            {code: 'BOUTIQUE', name: 'Boutique / Tailoring'},
            {code: 'JEWELRY', name: 'Jewelry Store'}
        ]
    },
    {
        group: 'Home & Services',
        categories: [
            {code: 'REAL_ESTATE', name: 'Real Estate Agent'},
            {code: 'MORTGAGE', name: 'Mortgage / Loan Officer'},
            {code: 'CLEANING', name: 'Cleaning Services'},
            {code: 'LANDSCAPING', name: 'Landscaping / Gardening'},
            {code: 'PLUMBING', name: 'Plumbing'},
            {code: 'ELECTRICAL', name: 'Electrical Services'},
            {code: 'HVAC', name: 'HVAC'},
            {code: 'HANDYMAN', name: 'Handyman'},
            {code: 'PEST_CONTROL', name: 'Pest Control'},
            {code: 'INTERIOR_DESIGN', name: 'Interior Design'}
        ]
    },
    {
        group: 'Professional & Business',
        categories: [
            {code: 'LEGAL', name: 'Attorney / Legal'},
            {code: 'ACCOUNTANT', name: 'Accountant / Tax Consultant'},
            {code: 'FINANCIAL', name: 'Financial Advisor'},
            {code: 'INSURANCE', name: 'Insurance Agent'},
            {code: 'CONSULTING', name: 'Business Consulting'},
            {code: 'MARKETING', name: 'Marketing / Advertising'},
            {code: 'NOTARY', name: 'Notary Services'},
            {code: 'IT', name: 'IT Consulting / Software'},
            {code: 'WEB_DEV', name: 'Web Development'}
        ]
    },
    {
        group: 'Education & Training',
        categories: [
            {code: 'TUTORING', name: 'Tutoring / Coaching'},
            {code: 'TEST_PREP', name: 'Test Prep'},
            {code: 'DANCE_MUSIC', name: 'Dance / Music Classes'},
            {code: 'DAYCARE', name: 'Daycare / Preschool'},
            {code: 'DRIVING', name: 'Driving School'},
            {code: 'SKILL_TRAINING', name: 'Skill Training / Vocational'}
        ]
    },
    {
        group: 'Retail & E-Commerce',
        categories: [
            {code: 'CLOTHING', name: 'Clothing Store'},
            {code: 'JEWELRY_RETAIL', name: 'Jewelry & Accessories'},
            {code: 'ELECTRONICS', name: 'Electronics'},
            {code: 'FURNITURE', name: 'Furniture'},
            {code: 'GIFT_SHOP', name: 'Gift Shop'},
            {code: 'ONLINE_STORE', name: 'Online Store / E-Commerce'}
        ]
    },
    {
        group: 'Automotive',
        categories: [
            {code: 'CAR_DEALERSHIP', name: 'Car Dealership'},
            {code: 'AUTO_REPAIR', name: 'Auto Repair'},
            {code: 'CAR_WASH', name: 'Car Wash / Detailing'},
            {code: 'AUTO_INSURANCE', name: 'Auto Insurance'}
        ]
    },
    {
        group: 'Events & Entertainment',
        categories: [
            {code: 'EVENT_PLANNER', name: 'Event Planner'},
            {code: 'PHOTOGRAPHER', name: 'Photographer'},
            {code: 'VIDEOGRAPHER', name: 'Videographer'},
            {code: 'DJ', name: 'DJ Services'},
            {code: 'EVENT_DECOR', name: 'Event Décor'},
            {code: 'VENUE_RENTAL', name: 'Venue Rental'}
        ]
    },
    {
        group: 'Travel & Hospitality',
        categories: [
            {code: 'TRAVEL_AGENT', name: 'Travel Agent'},
            {code: 'HOTEL', name: 'Hotel / Motel'},
            {code: 'TRANSPORT', name: 'Transportation / Taxi / Limo'},
            {code: 'TOUR_OPERATOR', name: 'Tour Operator'}
        ]
    },
    {
        group: 'Other',
        categories: [
            {code: 'OTHER', name: 'Other'}
        ]
    }
];
